import React, {useCallback} from "react";
import useRouteHandler from "../hook/useRouteHandler";
import logoImage from "../assets/svgs/sitebunny_logo.svg";
import classNames from "classnames";

type LogoProps = {
    onClick?: () => void,
    btnClassNames?: string
}

const Logo: React.FC<LogoProps> = ({onClick, btnClassNames}) => {
    const { moveToHome } = useRouteHandler()

    const onClickBanner = useCallback(() => {
        if (onClick) {
            onClick();
        } else {
            moveToHome();
        }
    }, [onClick, moveToHome])

    return (
        <button className={classNames("flex items-center space-x-[12px] w-[520px]", btnClassNames ?? "")}
                onClick={onClickBanner}>
            <img src={logoImage} alt="logo" width={32} height={32}/>
            <h1 className="text-[20px] font-semibold text-console-black font-pretendard"> SiteBunny </h1>
        </button>
    );
};

export default Logo;
